import { HttpClient } from "common/HttpClient";
import { Environment } from "enviroment/AppSettings";
import { 
  RequestKontomatikSetBank, 
  RequestKontomatikSetBankResponse, 
  RequestKontomatikSetSessionProps, 
  RequestKontomatikSetSessionResponse, 
} from './KontomatikServiceProps'


export class KontomatikService {
  private readonly _client: HttpClient;
  private readonly _bankChosenUrlPath = "/kontomatik/bankChosen"
  private readonly _bankKontomatikSessionUrlPath = "/kontomatik/session"

  constructor() {
    this._client = new HttpClient(Environment.apiUrl);
  }

  public async setBankChosen(dto: RequestKontomatikSetBank): Promise<RequestKontomatikSetBankResponse> {
    return (await this._client.post<RequestKontomatikSetBankResponse, RequestKontomatikSetBank>(this._bankChosenUrlPath, dto)).data;
  }

  public async setSessionData(dto: RequestKontomatikSetSessionProps): Promise<RequestKontomatikSetSessionResponse> {
    return (await this._client.post<RequestKontomatikSetSessionResponse, RequestKontomatikSetSessionProps>(this._bankKontomatikSessionUrlPath, dto, true));
  }
}